<ng-container *appLet="navProgressElements$ | async as navProgressElements">
  <section>
    @if (navProgressElements !== null && navProgressElements !== undefined) {
      @if (infoMessage?.showMessage) {
        <app-information-message class="hide-only-on-print" [message]="infoMessage"></app-information-message>
      }
      <app-expandable-data-alerts class="hide-only-on-print"></app-expandable-data-alerts>
    }
    <router-outlet></router-outlet>
  </section>

  @if (
    navProgressElements === null ||
    (!(simulationParametersPartialWithdrawalByEngagementEnable$ | async) && !(isSimulatingDifferentTimes$ | async))
    ) {
    <app-nav-progress [buttons$]="navigation$" [progress]="progress$ | async" [class.hide]="hideNavigation$ | async">
      @if (navProgressElements?.includes(NavProgressElements.Parameters)) {
        <app-simulation-params-activator
          class="hide-on-tablet"
          [simulateDifferentTimes]="isSimulatingDifferentTimes$ | async"
        ></app-simulation-params-activator>
      }
    </app-nav-progress>
  }
</ng-container>
